export default __webpack_public_path__ + "static/media/link.004a6e4c.svg";